// extracted by mini-css-extract-plugin
export default {"sender-wrap":"SenderList_sender-wrap__Mk4J+","rest-count":"SenderList_rest-count__Titde"};